import React, { useState } from 'react';
import { API_BASE_URL } from '../services/api';

const Login = ({ onLogin, onSwitchToRegister }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [mafCode, setMafCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [mafRequired, setMafRequired] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      let response;
      
      if (mafRequired && mafCode) {
        // 如果需要二次认证，使用带MAF的登录接口
        response = await fetch(`${API_BASE_URL}/auth/token-with-maf`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            username,
            password,
            maf_code: mafCode
          })
        });
      } else {
        // 标准登录流程
        const formData = new FormData();
        formData.append('username', username);
        formData.append('password', password);
        
        response = await fetch(`${API_BASE_URL}/auth/token`, {
          method: 'POST',
          body: formData
        });
      }

      const data = await response.json();

      if (response.ok) {
        // 登录成功
        onLogin(data.access_token, data.user);
      } else {
        console.log("test",response)
        if (response.status === 401 && response.headers.get('X-MAF-Required') === 'true') {
          // 需要二次认证
          setMafRequired(true);
          setError('请输入您的MAF验证码');
        } else {
          // 其他错误
          setError(data.detail || '登录失败');
        }
      }
    } catch (err) {
      setError('网络错误，请重试。');
    } finally {
      setLoading(false);
    }
  };

  const handleCancelMaf = () => {
    setMafRequired(false);
    setMafCode('');
    setError('');
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <h2>欢迎回来</h2>
        <p>请登录您的账户</p>
        
        {error && (
          <div className="error">
            <p>{error}</p>
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          {!mafRequired ? (
            <>
              <div className="form-group">
                <label htmlFor="username">用户名:</label>
                <input
                  type="text"
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  placeholder="输入您的用户名"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="password">密码:</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="输入您的密码"
                />
              </div>
            </>
          ) : (
            <div className="form-group">
              <label htmlFor="mafCode">MAF验证码:</label>
              <input
                type="text"
                id="mafCode"
                value={mafCode}
                onChange={(e) => setMafCode(e.target.value)}
                placeholder="输入6位验证码"
                maxLength="6"
                required
              />
              <div className="help-text">请输入您身份验证器应用中的验证码</div>
            </div>
          )}
          
          <button type="submit" className="primary-button" disabled={loading}>
            {loading ? '登录中...' : (mafRequired ? '验证MAF验证码' : '登录')}
          </button>
          
          {mafRequired && (
            <button type="button" onClick={handleCancelMaf} className="link-button" disabled={loading}>
              取消
            </button>
          )}
        </form>
        
        <div className="auth-switch">
          <p>
            还没有账户?{' '}
            <button onClick={onSwitchToRegister} className="link-button">
              点此注册
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;